import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Login.scss";
import OtpInput from 'react-otp-input';
import { useHistory } from "react-router-dom";
import logo from "../../assets/home/atar_logo.png";
import erroricon from "../../assets/home/erroricon.svg";
import { useSelector, useDispatch } from 'react-redux'
import { otpReSend, otpValidate, setLoginRedirectUrl } from '../../store/AuthRedux'
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'

const Otp = (props) => {
  const pageActive = useRef(false);
  const history = useHistory();
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const phone = useSelector((state) => state.auth.phone)
  const name = useSelector((state) => state.auth.name)
  const error = useSelector((state) => state.auth.error)
  const isFetching = useSelector((state) => state.auth.isFetching)
  const loginRedirectUrl = useSelector((state) => state.auth.loginRedirectUrl)
  const isReferral = useSelector((state) => state.auth.isReferral)
  const { t, i18n } = useTranslation();
  const [otp, setOtp] = useState('')
  const [time, setTime] = useState(0);
  let counter;


  useEffect(() => {
    window.scrollTo(0, 0)
    calculateTime()
    return () => {
      clearInterval(counter);
    }
  }, [])

  const calculateTime = () => {
    var timeleft = 30;
    counter = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(counter);
      }
      setTime(timeleft)
      timeleft = timeleft - 1;
    }, 1000)
  }

  const onAction = async () => {
    if (otp && otp.length === 4) {
      let params = {
        name: name,
        phone: phone,
        otp: otp,
      };
      pageActive.current = true;
      dispatch(otpValidate(params))
      setOtp('')
    }
  };

  const changeNumber = async () => {
    history.push("login");
  };

  useEffect(() => {
    if (token && pageActive.current) {
      if (isReferral) {
        history.push("/referral");
      } else if (loginRedirectUrl) {
        history.push(`/${loginRedirectUrl}`);
      } else {
        history.push("/");
      }
      dispatch(setLoginRedirectUrl(null))
    }
  }, [token]);

  return (
    <>
      <div className="container-fluid home clearall">
        <div className="bg">
          <div className="img_sec">
            <div className="singup_sec">
              <div className="singup">

                <NavLink
                  to="">
                  <img className="login_logo" src={logo} />
                </NavLink>
                <div className="dream_sec">
                  <div className="otpTitle">
                    <h2>{t("otp.titel")}</h2>
                    {error ? <div className="errer_sec"> <img className="ss" src={erroricon} />  <h5>{error}</h5></div> : null}
                  </div>
                  <p>
                    {t("otp.para")} {phone ? ('XXXXXXX' + (phone).slice(7)) : ''}
                  </p>
                  <div className="input-group mb-3">
                    {!isFetching && (
                      <div className={"otpForm " + (error ? 'inputError' : '')}><OtpInput
                        value={otp}
                        isInputNum={true}
                        onChange={(otp) => setOtp(otp)}
                        numInputs={4}
                        separator={<span></span>}
                      /></div>
                    )}
                  </div>
                  <div className="number_sec clearall">
                    <h4 onClick={changeNumber}>{t("otp.chang")}</h4>
                    {time == 0 ? <h3
                      style={{ cursor: "pointer" }}
                      onClick={() => { dispatch(otpReSend({ phone })); calculateTime() }}>
                      Resend code{" "}
                    </h3> : <h3>00:{String(time).length == 1 ? '0' + time : time}</h3>}
                  </div>
                  <div style={{ clear: 'both', marginTop: "29px" }}>
                    <StarButton background={'mainBg'} width="100%" title={t("otp.btn")} onClickAction={() => onAction()} isLoading={isFetching} disableStar={otp.length > 3 ? false : true} isGray={otp.length > 3 ? false : true} />
                  </div>
                  <div className="bellow_sec">
                    <h5 onClick={changeNumber}>{t("otp.change")}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp
